module.exports = __webpack_public_path__ + "static/media/ic_hi_b2_myway.00d621ca.svg";